export default __webpack_public_path__ + "static/media/Kismat R. Kathrani.e2cef53d.jpg";